var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "info-form",
              staticStyle: { "margin-top": "22px" },
              attrs: {
                "label-width": "110px",
                rules: _vm.rules,
                model: _vm.form,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户昵称", prop: "userName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: { placeholder: "请输入用户昵称" },
                    model: {
                      value: _vm.form.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "userName", $$v)
                      },
                      expression: "form.userName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户头像", prop: "userAvatar" } },
                [
                  _c("upload-picture", {
                    attrs: {
                      imageUrl: _vm.form.userAvatar,
                      width: "128px",
                      height: "128px",
                    },
                    on: { getUrl: _vm.getImage },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择商品", prop: "psGoodsId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: { placeholder: "请选择商品", readonly: "" },
                    on: { focus: _vm.selectGoods },
                    model: {
                      value: _vm.form.psGoodsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "psGoodsName", $$v)
                      },
                      expression: "form.psGoodsName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品规格", prop: "psGoodsSku" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "442px" },
                      attrs: {
                        placeholder: "请选择商品规格",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.psGoodsSku,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "psGoodsSku", $$v)
                        },
                        expression: "form.psGoodsSku",
                      },
                    },
                    _vm._l(_vm.skus, function (item) {
                      return _c("el-option", {
                        key: item.psGoodsSku,
                        attrs: {
                          label: item.psGoodsSkuName,
                          value: item.psGoodsSku,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论星数", prop: "star" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "442px" },
                      attrs: {
                        placeholder: "请选择星数",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.star,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "star", $$v)
                        },
                        expression: "form.star",
                      },
                    },
                    _vm._l(_vm.stars, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论时间", prop: "submitTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.form.submitTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "submitTime", $$v)
                      },
                      expression: "form.submitTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论内容", prop: "content" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      placeholder: "请输入评论内容",
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "评论图片" } },
                [
                  _c("upload-picture1", {
                    attrs: { limit: 100000, isCustomer: 1, list: _vm.fileList },
                    on: { changeImage: _vm.changeImage },
                  }),
                  _c("div", { staticClass: "messageI" }, [
                    _vm._v(
                      " 图片尺寸：建议上传大小不得超过2M,支持jpg、jpeg、png格式 "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "showFlag" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "442px" },
                      attrs: {
                        placeholder: "请选择状态",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.showFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "showFlag", $$v)
                        },
                        expression: "form.showFlag",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "显示", value: "true" },
                      }),
                      _c("el-option", {
                        attrs: { label: "隐藏", value: "false" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { height: "20px" } }),
          _c(
            "div",
            { staticClass: "back-btn" },
            [
              _c(
                "el-button",
                { attrs: { type: "info" }, on: { click: _vm.back } },
                [_vm._v("返回")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            "append-to-body": true,
            "close-on-click-modal": false,
            visible: _vm.dialogGoods,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogGoods = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "500px", "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    staticStyle: { width: "224px", "margin-right": "20px" },
                    attrs: {
                      placeholder: "请输入商品名称/商品编号",
                      size: "small",
                    },
                    model: {
                      value: _vm.goodsInfo,
                      callback: function ($$v) {
                        _vm.goodsInfo = $$v
                      },
                      expression: "goodsInfo",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.goodsList,
                    "show-header": false,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("img", {
                                staticStyle: {
                                  width: "72px",
                                  height: "56px",
                                  "margin-right": "12px",
                                },
                                attrs: { src: scope.row.imgUrl, alt: "" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    height: "56px",
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#333333" } },
                                    [_vm._v(_vm._s(scope.row.goodsName))]
                                  ),
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#999999" } },
                                    [
                                      _vm._v(
                                        " 商品编号：" +
                                          _vm._s(scope.row.goodsNo) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "align-items": "center",
                    height: "42px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageNo,
                      "page-sizes": [5, 10, 20, 30],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "end",
                "margin-top": "24px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "info-q",
                  on: {
                    click: function ($event) {
                      _vm.dialogGoods = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c("div", { staticClass: "info-s", on: { click: _vm.selectD } }, [
                _vm._v("确定"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }